import { Component, inject } from '@angular/core';
import { OrderSelectionService } from '../../../core/services/order-selection.service';

@Component({
    selector: 'app-start-order-btn',
    imports: [],
    templateUrl: './start-order-btn.html',
    styleUrl: './start-order-btn.scss',
})
export class StartOrderBtn {
    orderSelection = inject(OrderSelectionService);

    async onStartOrder() {
        if (this.orderSelection.highestRestrictionLevel() === 2) {
            this.orderSelection.showCase2Modal.set(true);
        } else {
            this.orderSelection.startOrder();
        }

        try {
            await this.orderSelection.fetchDocumentPrices();
        } catch (error) {
            console.error('[StartOrderBtn] Error fetching document prices:', error);
        }
    }
}
